import {UseMutationResult, useMutation} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import useChatRestClient from '@/Api/ChatRestClient';

interface SubmitFeedbackPayload {
  student_id: number;
  webinar_id: number;
  rating: number; // Coach rating
  reason_ids: number[]; // Coach improvement reasons
  cc_rating: number; // CircleChess rating
  cc_reason_ids: number[]; // CircleChess improvement reasons
  comment?: string; // Coach feedback text
  cc_comment?: string; // CircleChess feedback text
  is_submitted: boolean;
  source?: 'app' | 'whatsapp' | 'web';
}

interface SubmitFeedbackResponse {
  status: string;
  message: string;
}

export default function useSubmitStudentClassFeedback(
  handleOnSuccess?: (data: SubmitFeedbackResponse) => void,
): UseMutationResult<SubmitFeedbackResponse, Error, SubmitFeedbackPayload> {
  const ChatRestClient = useChatRestClient();

  return useMutation<SubmitFeedbackResponse, Error, SubmitFeedbackPayload>(
    async (payload: SubmitFeedbackPayload) => {
      const token = await getLocalStorage('access_token');

      const options: any = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      return ChatRestClient.post(
        'tournament/v1/submit_student_class_feedback',
        JSON.stringify(payload),
        options,
      );
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        console.error('Failed to submit class feedback:', error);
      },
    },
  );
}
